import { Paper, ProgressBar, Typography } from "matsuri-ui"
import { PropsWithChildren, ReactNode } from "react"
import { css } from "@emotion/react"
import styled from "@emotion/styled"
import CloseIcon from "@mui/icons-material/Close"
import { useMobileLayoutProps } from "@/hooks/useMobileLayoutProps"
import { MobileAppHeader } from "@/components/Header/MobileAppHeader"
import { ReportFooter } from "@/components/Footer/ReportFooter"
import { theme } from "@/theme"

const HeaderTitle = styled.h2`
    font-size: 20px;
    font-weight: bold;
    color: ${theme.palette.intentions.text.primary};
`

const HeaderProgressBarArea = styled.div`
    padding: 0 48px 16px 48px;
    text-align: center;
`

const MobileBody = styled.div`
    padding: 0 1em;
`

export const PhotoPageLayout = (
    props: PropsWithChildren<{
        headerTitle: string
        progressBar: {
            value: number
            max: number
        }
        page: {
            title: string
            description: string
        }
        navigationButtons?: ReactNode /* 画面上部に表示するボタン(一般的な名前がわからなかったので適当につけました) */
        footer?: ReactNode
        onNext?: () => void
    }>
) => {
    const { rootProps, headerProps, bodyProps, footerProps } =
        useMobileLayoutProps<HTMLDivElement>()

    return (
        <main {...rootProps}>
            <Paper
                square
                {...headerProps}
                style={{
                    backgroundColor:
                        theme.palette.intentions.cleanerBackground.main,
                    position: "fixed",
                    width: "100%",
                    zIndex: 99,
                    top: 0,
                    boxSizing: "border-box",
                    paddingTop: "env(safe-area-inset-top, 0px)"
                }}
            >
                <MobileAppHeader
                    title={<HeaderTitle>{props.headerTitle}</HeaderTitle>}
                    onNext={props.onNext}
                    nextIcon={<CloseIcon />}
                >
                    <HeaderProgressBarArea>
                        <ProgressBar
                            color="accent"
                            value={props.progressBar.value}
                            max={props.progressBar.max}
                        />
                        <Typography>
                            {props.progressBar.value}/{props.progressBar.max}
                        </Typography>
                    </HeaderProgressBarArea>
                </MobileAppHeader>
            </Paper>
            <MobileBody {...bodyProps}>
                <div
                    css={css`
                        margin-top: 16px;
                    `}
                >
                    {props.navigationButtons}
                </div>

                <Typography
                    variant="h2"
                    css={css`
                        padding-top: 24px;
                        padding-bottom: 24px;
                        font-size: 20px;
                        font-weight: bold;
                        text-align: center;
                    `}
                >
                    {props.page.title}
                </Typography>
                <Typography>{props.page.description}</Typography>

                {props.children}
            </MobileBody>
            <ReportFooter {...footerProps}>{props.footer}</ReportFooter>
        </main>
    )
}
